/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as ChaptersIdRouteImport } from './routes/chapters.$id'
import { Route as GearIndexRouteImport } from './routes/gear.index'
import { Route as GearCatalogRouteImport } from './routes/gear.catalog'
import { Route as MonstersIndexRouteImport } from './routes/monsters.index'
import { Route as MonstersIdRouteImport } from './routes/monsters.$id'
import { Route as PagesSlugRouteImport } from './routes/pages.$slug'
import { Route as PagesNewRouteImport } from './routes/pages.new'
import { Route as SkillsIndexRouteImport } from './routes/skills.index'
import { Route as SkillsIdRouteImport } from './routes/skills.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const ChaptersIdRoute = ChaptersIdRouteImport.update({
  id: '/chapters/$id',
  path: '/chapters/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const GearIndexRoute = GearIndexRouteImport.update({
  id: '/gear/',
  path: '/gear/',
  getParentRoute: () => rootRouteImport,
} as any)
const GearCatalogRoute = GearCatalogRouteImport.update({
  id: '/gear/catalog',
  path: '/gear/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const MonstersIndexRoute = MonstersIndexRouteImport.update({
  id: '/monsters/',
  path: '/monsters/',
  getParentRoute: () => rootRouteImport,
} as any)
const MonstersIdRoute = MonstersIdRouteImport.update({
  id: '/monsters/$id',
  path: '/monsters/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesSlugRoute = PagesSlugRouteImport.update({
  id: '/pages/$slug',
  path: '/pages/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesNewRoute = PagesNewRouteImport.update({
  id: '/pages/new',
  path: '/pages/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillsIndexRoute = SkillsIndexRouteImport.update({
  id: '/skills/',
  path: '/skills/',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillsIdRoute = SkillsIdRouteImport.update({
  id: '/skills/$id',
  path: '/skills/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/rules': typeof RulesRoute
  '/chapters/$id': typeof ChaptersIdRoute
  '/gear/catalog': typeof GearCatalogRoute
  '/monsters/$id': typeof MonstersIdRoute
  '/pages/$slug': typeof PagesSlugRoute
  '/pages/new': typeof PagesNewRoute
  '/skills/$id': typeof SkillsIdRoute
  '/gear/': typeof GearIndexRoute
  '/monsters/': typeof MonstersIndexRoute
  '/skills/': typeof SkillsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/rules': typeof RulesRoute
  '/chapters/$id': typeof ChaptersIdRoute
  '/gear/catalog': typeof GearCatalogRoute
  '/monsters/$id': typeof MonstersIdRoute
  '/pages/$slug': typeof PagesSlugRoute
  '/pages/new': typeof PagesNewRoute
  '/skills/$id': typeof SkillsIdRoute
  '/gear': typeof GearIndexRoute
  '/monsters': typeof MonstersIndexRoute
  '/skills': typeof SkillsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/rules': typeof RulesRoute
  '/chapters/$id': typeof ChaptersIdRoute
  '/gear/catalog': typeof GearCatalogRoute
  '/monsters/$id': typeof MonstersIdRoute
  '/pages/$slug': typeof PagesSlugRoute
  '/pages/new': typeof PagesNewRoute
  '/skills/$id': typeof SkillsIdRoute
  '/gear/': typeof GearIndexRoute
  '/monsters/': typeof MonstersIndexRoute
  '/skills/': typeof SkillsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/rules'
    | '/chapters/$id'
    | '/gear/catalog'
    | '/monsters/$id'
    | '/pages/$slug'
    | '/pages/new'
    | '/skills/$id'
    | '/gear/'
    | '/monsters/'
    | '/skills/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/rules'
    | '/chapters/$id'
    | '/gear/catalog'
    | '/monsters/$id'
    | '/pages/$slug'
    | '/pages/new'
    | '/skills/$id'
    | '/gear'
    | '/monsters'
    | '/skills'
  id:
    | '__root__'
    | '/'
    | '/rules'
    | '/chapters/$id'
    | '/gear/catalog'
    | '/monsters/$id'
    | '/pages/$slug'
    | '/pages/new'
    | '/skills/$id'
    | '/gear/'
    | '/monsters/'
    | '/skills/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  RulesRoute: typeof RulesRoute
  ChaptersIdRoute: typeof ChaptersIdRoute
  GearCatalogRoute: typeof GearCatalogRoute
  MonstersIdRoute: typeof MonstersIdRoute
  PagesSlugRoute: typeof PagesSlugRoute
  PagesNewRoute: typeof PagesNewRoute
  SkillsIdRoute: typeof SkillsIdRoute
  GearIndexRoute: typeof GearIndexRoute
  MonstersIndexRoute: typeof MonstersIndexRoute
  SkillsIndexRoute: typeof SkillsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chapters/$id': {
      id: '/chapters/$id'
      path: '/chapters/$id'
      fullPath: '/chapters/$id'
      preLoaderRoute: typeof ChaptersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gear/': {
      id: '/gear/'
      path: '/gear'
      fullPath: '/gear/'
      preLoaderRoute: typeof GearIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gear/catalog': {
      id: '/gear/catalog'
      path: '/gear/catalog'
      fullPath: '/gear/catalog'
      preLoaderRoute: typeof GearCatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/monsters/': {
      id: '/monsters/'
      path: '/monsters'
      fullPath: '/monsters/'
      preLoaderRoute: typeof MonstersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/monsters/$id': {
      id: '/monsters/$id'
      path: '/monsters/$id'
      fullPath: '/monsters/$id'
      preLoaderRoute: typeof MonstersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/$slug': {
      id: '/pages/$slug'
      path: '/pages/$slug'
      fullPath: '/pages/$slug'
      preLoaderRoute: typeof PagesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/new': {
      id: '/pages/new'
      path: '/pages/new'
      fullPath: '/pages/new'
      preLoaderRoute: typeof PagesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skills/': {
      id: '/skills/'
      path: '/skills'
      fullPath: '/skills/'
      preLoaderRoute: typeof SkillsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skills/$id': {
      id: '/skills/$id'
      path: '/skills/$id'
      fullPath: '/skills/$id'
      preLoaderRoute: typeof SkillsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  RulesRoute: RulesRoute,
  ChaptersIdRoute: ChaptersIdRoute,
  GearCatalogRoute: GearCatalogRoute,
  MonstersIdRoute: MonstersIdRoute,
  PagesSlugRoute: PagesSlugRoute,
  PagesNewRoute: PagesNewRoute,
  SkillsIdRoute: SkillsIdRoute,
  GearIndexRoute: GearIndexRoute,
  MonstersIndexRoute: MonstersIndexRoute,
  SkillsIndexRoute: SkillsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
